var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1307 958.7",
    style: {
      enableBackground: "new 0 0 1307 958.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\t.st0 {\n\t\t\tfill-rule: evenodd;\n\t\t\tclip-rule: evenodd;\n\t\t\tfill: #000;\n\t\t}\n\n\t\t.st1 {\n\t\t\tfill: #000;\n\t\t}\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M851.5,622.1h99v-99h-99V622.1z M851.5,443.9h99v-99h-99V443.9z M851.5,107.3h99v-99h-99V107.3z M851.5,285.5 h99v-99h-99V285.5z M537,0H341.3v394c33,18.4,74.2,43.7,111.1,73.5v-360h76.1c58,0,87,34.2,87,102.7v525.4 c0,68.5-29,102.7-87,102.7h-14c-17,42-42.1,80.1-78.9,107.5H537c58,0,103.9-17.7,137.7-53.1c33.8-35.4,50.7-90.2,50.7-164.3v-511 c0-74.1-16.9-128.8-50.7-164.3C640.9,17.7,595,0,537,0z M851.5,780.5h99v-99h-99V780.5z M1208,958.7h99v-99h-99V958.7z  M1208,443.9h99v-99h-99V443.9z M1208,285.5h99v-99h-99V285.5z M1208,622.1h99v-99h-99V622.1z M1208,780.5h99v-99h-99V780.5z  M1029.8,523.1h99v-99h-99V523.1z M1208,8.3v99h99v-99H1208z M851.5,958.7h99v-99h-99V958.7z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M237.7,542.9c42.3,0,82.1,16.5,112,46.4c29.9,29.9,46.4,69.7,46.4,112c0,42.3-16.5,82.1-46.4,112 c-29.9,29.9-69.7,46.4-112,46.4c-42.3,0-82.1-16.5-112-46.4c-29.9-29.9-46.4-69.7-46.4-112s16.5-82.1,46.4-112 C155.6,559.4,195.3,542.9,237.7,542.9 M237.7,463.7C106.4,463.7,0,570.1,0,701.3C0,832.6,106.4,939,237.7,939 c131.2,0,237.6-106.4,237.6-237.6C475.3,570.1,368.9,463.7,237.7,463.7L237.7,463.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.df9744d2c4ea806f86ba5f0901a43230.svg";
export { ForwardRef as ReactComponent };